module.exports = __webpack_public_path__ + "static/media/galleryPhoto.3b5f783d.png";